import { FunctionComponent } from 'react';
import { AppBar, Container, Toolbar, styled } from '@mui/material';
import UserMenu from './UserMenu';
import StartOverButton from './StartOverButton';

const StyledToolbar = styled(Toolbar)({
  padding: '20px 0',
  justifyContent: 'space-between',
  float: 'right',
});

const Bar: FunctionComponent<{
  disableGutters?: boolean;
  disableStartOver?: boolean;
}> = ({ disableGutters, disableStartOver }) => {
  return (
    <AppBar color="transparent" position="static" elevation={0}>
      <Container disableGutters={disableGutters}>
        <StyledToolbar disableGutters>
          <div>
            {!disableStartOver && <StartOverButton />}
            <UserMenu />
          </div>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
};

export default Bar;
